import { getInvoices } from "@/api/invoices/get-invoices";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import DashboardPie from "./DashboarPie";
import shorcut1 from "../assets/Shorcut1.png";
import { Link } from "react-router-dom";

export function DashboardCards() {
  const { data: invoices } = useQuery({
    queryKey: ["invoices"],
    queryFn: () => getInvoices(),
  });

  const invoicesRevenue = invoices?.invoices.reduce(
    (acc, invoice) => acc + invoice.totalPrice,
    0,
  );

  function RevenueFormatter(Revenue: number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(Revenue);
  }
  // TODO : add linear Chart for revenue and the second shorcut
  return (
    <div className="mx-auto max-h-screen max-w-7xl font-Hemmers">
      <div className="grid grid-cols-4 gap-5 p-5">
        <Link to="/invoices/create">
          <Card className="max-h-[176px] rounded-3xl border-black">
            <CardTitle className="p-5 text-xl">Shorcut</CardTitle>

            <CardContent>
              <div className="flex flex-col items-center justify-center gap-3">
                <img
                  src={shorcut1}
                  alt="Shorcut1"
                  className="h-[60px] w-[60px]"
                />
                <p>Create a new invoice</p>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Card className="max-h-[176px] rounded-3xl border-black">
          <CardHeader>
            <CardTitle className="text-xl">Shorcut</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <span className="text-pretty font-bold">Monthly Revenue </span>
              <h1 className="font-semibold">
                {RevenueFormatter(invoicesRevenue!)}
              </h1>
            </div>
          </CardContent>
        </Card>

        <Card className="rounded-3xl border-black shadow-2xl">
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center gap-2">
              <span className="text-nowrap text-xl">Total Invoices</span>
              <span className="text-nowrap text-xs text-zinc-400">
                this month
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-center">
              <h1 className="py-1 text-4xl font-semibold text-purple-600">
                {invoices?.totalInvoices}
              </h1>
            </div>
            <div className="flex items-center gap-5">
              <span className="text-green-500">+18%</span>
              <span className="text-nowrap">+7.8k this week.</span>
            </div>
          </CardContent>
        </Card>
        <Card className="rounded-3xl border-black">
          <CardHeader>
            <CardTitle className="text-xl">Revenue</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <span className="text-pretty font-bold">Monthly Revenue</span>
              <h1 className="font-semibold">
                {RevenueFormatter(invoicesRevenue!)}
              </h1>
            </div>
          </CardContent>
        </Card>
      </div>
      <div className="grid grid-cols-6 gap-4 p-4">
        <Card className="col-span-4 border-black">
          <CardHeader>
            <CardTitle>Revenue</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="">
              <span className="text-pretty font-bold">Monthly Revenue</span>

              <DashboardPie />

              <h1 className="font-semibold">
                {RevenueFormatter(invoicesRevenue!)}
              </h1>
            </div>
          </CardContent>
        </Card>
        <Card className="col-span-2 border-black">
          <CardHeader>
            <CardTitle>Revenue</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="">
              <span className="text-pretty font-bold">Monthly Revenue</span>

              <DashboardPie />

              <h1 className="font-semibold">
                {RevenueFormatter(invoicesRevenue!)}
              </h1>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
